// extracted by mini-css-extract-plugin
module.exports = {"modal":"VideoPlayerModal_modal__3wcsD","video":"VideoPlayerModal_video___wJID"};